import React from "react";

export default function Badge({ color, children, style = {} }) {
  return (
    <span
      style={{
        display: "inline-block",
        padding: "2px 10px",
        borderRadius: 20,
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: 1.5,
        border: `1px solid ${color}`,
        color,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
